"use strict";
$(function () {

    if (window.location.pathname !== "/") {
        return false;
    }


    $('.init-order-button').click(function (e) {
        e.preventDefault();

        const $form = $(this).parents('form');
        const $allInputs = $form.find('input');
        let selected_packet = {};

        for (let i = 0; i < $allInputs.length; i++) {

            const $input = $($allInputs[i]);

            if($input.hasClass('checkbox')) {
                const checked = $("input[name='" + $input.attr('name') + "']:checked").length;

                if (checked) {
                    if (!("additional_services" in selected_packet))
                        selected_packet['additional_services'] = {};

                    const components = $input.attr('name').split('-');
                    const name = components[0];
                    const price = components[2];
                    const label = $('label[for="'+$input.attr('name')+'"]').html();

                    selected_packet['additional_services'][i] = {"name": name, "price": price, "label": label };
                }

            } else {
                selected_packet[$input.attr('class')] = $input.attr('value');
            }
        }

        sessionStorage.setItem('packet_selection', JSON.stringify(selected_packet));
        window.location.href = $(this).attr('href');

    })

    if(window.location.hostname.includes('veebipood24')){

        $('.contact-info-block-veebileht').remove();
        $('.contact-info-block-veebipood').removeClass('hide');

        const $vlTab = $('.veebileht-tab')[0].outerHTML;
        const $vpTab = $('.veebipood-tab')[0].outerHTML;

        $('.active-shop-tabs').html($vpTab+$vlTab);

        $('.veebileht-tab').removeClass('active');
        $('.veebipood-tab').addClass('active');

        $('#veebileht').addClass('hide');
        $('#veebipood').removeClass('hide');

        $('.active-shop-tabs a').bind('click', function (e) {
            e.preventDefault();

            if ($(this).hasClass('veebipood-tab')) {

                $('.veebileht-tab').removeClass('active');
                $('.veebipood-tab').addClass('active');

                $('#veebileht').addClass('hide');
                $('#veebipood').removeClass('hide');

            } else {
                $('.veebileht-tab').addClass('active');
                $('.veebipood-tab').removeClass('active');

                $('#veebileht').removeClass('hide');
                $('#veebipood').addClass('hide');

            }


        });



    } else {
        $('.contact-info-block-veebileht').removeClass('hide');
        $('.contact-info-block-veebipood').remove();
    }


});